import { useAuthorizeUser } from "@coworker/apprestructured/src/shared/hooks/useAuthorizeUser";
import { SimpleDefaultLoadingScreen } from "@coworker/apprestructured/src/shared/simple/SimpleLoading/SimpleDefaultLoadingScreen";
import { Error } from "@coworker/apprestructured/src/login/components/Error/Error";
import { ErrorType } from "@coworker/apprestructured/src/shared/constants/errorTypes";
import { ReactElement } from "react";
import { NewUserPage } from "@coworker/apprestructured/src/login/components/NewUserPage/NewUserPage";

export const AuthorizedUserRoute = ({
  children,
}: {
  children: ReactElement;
}) => {
  const userState = useAuthorizeUser();

  if (userState.isLoading) {
    return <SimpleDefaultLoadingScreen />;
  }

  // Redirect to NewUserPage for users that are not fully provisioned yet
  if (userState.errorType === ErrorType.NOTFOUND) {
    return <NewUserPage />;
  }

  if (userState.isError) {
    return (
      <Error isAccessIssue={userState.errorType === ErrorType.FORBIDDEN} />
    );
  }

  return userState?.isActive ? children : <Error isAccessIssue={false} />;
};
